import Http from '@/api/http.js'

export default {

  index(filter) {
    
    return Http.get('/pay_traces', {params: {...filter}})
  },
  indexByParams(filter) {
    return Http.get('/pay_traces/by_params', {params: {...filter}})
  },

  indexByModel(model, model_id) {
    return Http.get(`/${model}/${model_id}/pay_traces`)
  },

  show(id, details) {
    return Http.get(`/pay_traces/${id}`, { params: {...details}});
  }, 

  delete(id){
    return Http.delete(`/pay_traces/${id}`)
  }

}